import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../style/Toast.scss";
const CustomToast = ({ message, type }) => {
  return (
    <div className={`custom-toast ${type}`}>
      <span>{message}</span>
    </div>
  );
};

const Toast = {
  success: (message) => {
    toast.success(<CustomToast message={message} type="success" />, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },
  error: (message) => {
    toast.error(<CustomToast message={message} type="error" />, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },
};

export default Toast;
